<template>
  <b-container fluid>
    <b-table bordered responsive :fields="orderTableFields" :items="orders">
      <template slot="HEAD_selection">
        <b-form-checkbox
          v-model="selectionAll"
          :disabled="orders.length <= 0"
          @change="selectedAll"
        />
      </template>
      <template slot="selection" slot-scope="data">
        <b-form-checkbox v-model="ordersSelected" :value="data.item.id" />
      </template>
      <template slot="ln" slot-scope="data">
        <div class="col-right">
          {{ data.item.ln }}
        </div>
      </template>
      <template slot="animal_name" slot-scope="data">
        <div class="col-left">
          {{ data.item.animal_name }}
        </div>
      </template>
      <template slot="test_amount" slot-scope="data">
        <div class="col-right">
          {{ data.item.test_amount }}
        </div>
      </template>
      <template slot="amount" slot-scope="data">
        <div class="col-right">
          {{ data.item.amount }}
        </div>
      </template>
      <template slot="latest_approve.user.name" slot-scope="data">
        <div class="col-left">
          {{ data.item.latest_approve.user.name }}
        </div>
      </template>
    </b-table>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "OrderTableSelection",
  props: {
    orders: {
      required: true,
    },
    // ordersSelected: {
    //   type: Array
    // }
  },
  computed: {
    ...mapGetters({
      // orders: 'Account/getOrders',
    }),
    ordersSelected: {
      get() {
        return this.$store.state.Account.ordersSelected;
      },
      set(value) {
        this.$store.commit("Account/SET_ORDERS_SELECTED", value);
      },
    },
  },
  data() {
    return {
      orderTableFields: {
        selection: {},
        ln: {
          label: "LN",
          key: "ln",
          sortable: true,
        },
        patient: {
          label: "PATIENT",
          key: "animal_name",
          sortable: true,
        },
        lnAmount: {
          label: "จำนวนตรวจ",
          key: "test_amount",
          sortable: true,
        },
        totalAmount: {
          label: "ราคารวม",
          key: "amount",
          sortable: true,
        },
        createdDate: {
          label: "วันที่สั่งตรวจ",
          key: "order_date",
          sortable: true,
        },
        approver: {
          label: "ผู้อนุมัติ",
          key: "latest_approve.user.name",
          sortable: true,
        },
      },
      selectionAll: false,
    };
  },
  watch: {
    orders(newVal) {
      this.ordersSelected.forEach((order) => {
        let findOrder = this.orders.find((el) => el.id === order);
        if (!findOrder) {
          let index = this.ordersSelected.findIndex((el) => order === el);
          this.ordersSelected.splice(index, 1);
        }
      });
    },
    ordersSelected() {
      if (this.ordersSelected.length > 0) {
        this.selectionAll = this.ordersSelected.length === this.orders.length;
      } else {
        this.selectionAll = false;
      }
    },
  },
  methods: {
    selectedAll(value) {
      if (value)
        this.ordersSelected = [...this.orders.map((order) => order.id)];
      else this.ordersSelected = [];
    },
  },
};
</script>

<style scoped></style>
